export default __webpack_public_path__ + "static/media/bedroomW112-A13-EI60 .078cec2e.jpg";